'use client';

import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { HeaderSponsorProps } from './siteNav.types';

type HeaderSponsorContextType = {
  sponsors: HeaderSponsorProps[];
  setSponsors: (sponsors: HeaderSponsorProps[]) => void;
};

const HeaderSponsorContext = createContext<HeaderSponsorContextType>({
  sponsors: [],
  setSponsors: () => {},
});

export const HeaderSponsorProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [sponsors, setSponsors] = useState<HeaderSponsorProps[]>([]);

  const value = useMemo(() => ({ sponsors, setSponsors }), [sponsors]);

  return (
    <HeaderSponsorContext.Provider value={value}>
      {children}
    </HeaderSponsorContext.Provider>
  );
};

export const useHeaderSponsors = () => useContext(HeaderSponsorContext);
